import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import IconButton from '@material-ui/core/IconButton'

import { TableTitle } from '../../common'

import * as Strings from './strings'
import * as configActions from '../../../actions/Config'

class SettingsTable extends Component {
  render() {
    const { classes, data, user, config } = this.props
    const parsedUserInformation = [
      {
        name: Strings.default.ASSOCIATION[config.language],
        value: data.community.name
      },
      {
        name: Strings.default.APARTMENT[config.language],
        value: data.apartment.number
      },
      {
        name: Strings.default.EMAIL[config.language],
        value: data.user.email,
        onEdit: user.offlineModeSignedIn
          ? null
          : () => this.props.showEditEmailModal()
      },
      {
        name: Strings.default.PASSWORD[config.language],
        value: '********',
        onEdit: user.offlineModeSignedIn
          ? null
          : () => this.props.showEditPasswordModal()
      }
    ]

    return (
      <Paper className={classes.root}>
        <TableTitle
          classes={classes}
          header={Strings.default.MY_INFORMATION[config.language]}
          withBottomBorder
        />
        <Table className={classes.table} aria-labelledby={'tableTitle'}>
          <TableBody>
            {parsedUserInformation.map(info => {
              return (
                <TableRow key={user.id} className={classes.row}>
                  <TableCell>{info.name}</TableCell>
                  <TableCell>{info.value}</TableCell>
                  <TableCell numeric>
                    {info.onEdit ? (
                      <IconButton
                        aria-label={'Ändra'}
                        onClick={() => info.onEdit()}
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          color={'#3B424D'}
                          style={{ fontSize: 16 }}
                        />
                      </IconButton>
                    ) : null}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

const Styles = {
  root: {
    width: '90%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa'
    }
  },
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: 'green'
  },
  title: {
    flex: '0 0 auto'
  }
}

SettingsTable.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user, config }) {
  return { data, user, config }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SettingsTable)



// WEBPACK FOOTER //
// ./src/components/containers/SettingsTable/index.js